import React, { useEffect, useRef } from 'react';
import styles from './style.module.scss';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function Index({ data, setSelectedProject }) {
  return (
    <div className={styles.titles}>
      {data.map((project, i) => (
        <Title key={i} data={{ ...project, i }} setSelectedProject={setSelectedProject} />
      ))}
    </div>
  );
}

function Title({ data, setSelectedProject }) {
  const { title, speed, i } = data;
  const container = useRef(null);
  const textRef = useRef(null);

  useEffect(() => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: container.current,
        start: 'top bottom',
        end: 'top top',
        scrub: 0.3,
      },
    });

    timeline.to(textRef.current, {
      clipPath: `inset(0 0 0 ${100 / speed}%)`,
    });

    return () => {
      if (timeline.scrollTrigger) timeline.scrollTrigger.kill();
    };
  }, [speed]);

  return (
    <div ref={container} className={styles.title}>
      <div
        className={styles.wrapper}
        onMouseOver={() => setSelectedProject(i)}
        onMouseLeave={() => setSelectedProject(null)}
      >
        <p ref={textRef} className={styles.animatedText}>
          {title}
        </p>
        <p>
          {title}
        </p>
      </div>
    </div>
  );
}
